document.addEventListener('DOMContentLoaded', function () {
  if (localStorage.getItem('storedDiscount')) {
    var discountStored = localStorage.getItem('storedDiscount');
    document.querySelector('input[data-cart-coupon-input]').value =
      localStorage.getItem('storedDiscount');
  }
  document
    .querySelector('form[action="/cart"]')
    .addEventListener('submit', function (event) {
      var discountCode = document.querySelector(
        'input[data-cart-coupon-input]'
      ).value;
      localStorage.setItem('storedDiscount', discountCode);
    });

  // Change ShopPay learn more to icon
  const shadowRoot = document
    .querySelector('shopify-payment-terms')
    .shadowRoot.querySelector('shop-pay-installments-banner').shadowRoot;

  const learnMoreButton = shadowRoot.querySelector(
    '.shopify-installments__learn-more'
  );

  // Change the inner text of the targeted element
  if (learnMoreButton) {
    learnMoreButton.innerText = 'ⓘ';
    shadowRoot.append(
      Object.assign(document.createElement('STYLE'), {
        innerText: `.shopify-installments__learn-more {
					text-decoration: none;
					font-size: smaller;
				}`,
      })
    );
  }
});
